import { combineReducers } from 'redux';
import loginReducer from 'store/login/loginReducer';
import basicDetailsReducer from 'store/SuperAdmin/basicDetails/reducer';
import addCategoryReducer from 'store/SuperAdmin/addCategory/reducer';
import addSubCategoryReducer from 'store/SuperAdmin/addSubCategory/reducer';
import addServiceReducer from 'store/SuperAdmin/addService/reducer';
import deleteCategoryReducer from 'store/SuperAdmin/deleteCategory/reducer';
import deleteSubCategoryReducer from 'store/SuperAdmin/deleteSubCategory/reducer';
import deleteServiceReducer from 'store/SuperAdmin/deleteService/reducer';
import getCategoryReducer from 'store/SuperAdmin/getCategory/reducer';
import getSubCategoryReducer from 'store/SuperAdmin/getSubCategory/reducer';
import updateCategoryReducer from 'store/SuperAdmin/updateCategory/reducer';
import updateSubCategoryReducer from 'store/SuperAdmin/updateSubCategory/reducer';
import updateServiceReducer from 'store/SuperAdmin/updateService/reducer';
import addAppointmentsReducer from 'store/ProviderAdmin/addAppointments/reducer';
import getAppointmentsReducer from 'store/ProviderAdmin/getAppointments/reducer';
import updateAppointmentsReducer from 'store/ProviderAdmin/updateAppointments/reducer';
import registerInviteBusinessReducer from 'store/ProviderAdmin/registerInviteBusiness/reducer';
import createPasswordReducer from 'store/ProviderAdmin/createPassword/reducer';
import tokenVerifyReducer from 'store/ProviderAdmin/tokenVerify/reducer';
import getAllProviderListReducer from 'store/SuperAdmin/getAllProviderList/reducer';
import getAllProviderListDetailsReducer from 'store/SuperAdmin/getAllProviderListDetails/reducer';
import promoteProviderReducer from 'store/SuperAdmin/promoteProvider/reducer';
import onHoldProviderReducer from 'store/SuperAdmin/onHoldProvider/reducer';
import addSalonProviderReducer from 'store/SuperAdmin/addSalonProvider/reducer';
import addCompanyProviderReducer from 'store/SuperAdmin/addCompanyProvider/reducer';
import countryCityDropdownReducer from 'store/CountryCityList/reducer';
import imageUploadReducer from 'store/ImageUpload/reducer';
import updateAllProviderListDetailsReducer from 'store/SuperAdmin/updateAllProviderListDetails/reducer';
import addCompanyBranchProviderReducer from 'store/ProviderAdmin/addCompanyBranchProvider/reducer';
import userMeReducer from 'store/UserMeDetails/reducer';
import getCompanyBranchProviderReducer from 'store/ProviderAdmin/getCompanyBranchProvider/reducer';
import createSpecialistProviderReducer from 'store/ProviderAdmin/createSpecialistProvider/reducer';
import getSpecialistProviderReducer from 'store/ProviderAdmin/getSpecialistProvider/reducer';
import updateSpecialistStatusProviderReducer from 'store/ProviderAdmin/statusUpdateSpecialistProvider/reducer';
import getAllProviderInformationDetailsReducer from 'store/SuperAdmin/getAllProviderInformation/reducer';
import getBasicProviderInforrmationReducer from 'store/SuperAdmin/basicProviderInformation/reducer';
import getBranchDetailsProviderReducer from 'store/ProviderAdmin/getBranchDetailsProvider/reducer';
import deleteBranchListReducer from 'store/ProviderAdmin/deleteBranchProvider/reducer';
import getDashboardDataReducer from 'store/SuperAdmin/dashboard/reducer';
import getCustomerReducer from 'store/SuperAdmin/getCustomerList/reducer';
import getAppointmentReducer from 'store/SuperAdmin/getAppointmentList/reducer';
import getAppointmentDetailsReducer from 'store/SuperAdmin/getAppointmentDetails/reducer';
import getCustomerDetailsReducer from 'store/SuperAdmin/getCustomerDetails/reducer';
import getDashboardProviderDataReducer from 'store/ProviderAdmin/dashboard/reducer';
import cancelSpecialistInvitationReducer from 'store/ProviderAdmin/cancelSpecialistInvitation/reducer';
import updateCompanyBranchProviderReducer from 'store/ProviderAdmin/updateCompanyBranchProvider/reducer';
import getCustomerProviderReducer from 'store/ProviderAdmin/getCustomerList/reducer';
import getAppointmentsListReducer from 'store/ProviderAdmin/getAppointmentList/reducer';
import getCustomerDetailProviderReducer from 'store/ProviderAdmin/customerDetails/reducer';
import getAppointmentDaysReducer from 'store/AppointmentDaysList/reducer';
import deleteProviderReducer from 'store/SuperAdmin/deleteProvider/reducer';
import cancelAppointmentReducer from 'store/SuperAdmin/cancelAppointment/reducer';
import cancelAppointmentProviderAdminReducer from 'store/ProviderAdmin/cancelAppointment/reducer';
import updateProfileReducer from 'store/ProviderAdmin/updateProfile/reducer';
import deleteCustomerProviderReducer from 'store/ProviderAdmin/deleteCustomer/reducer';
import deleteCustomerSuperAdminReducer from 'store/SuperAdmin/deleteCustomer/reducer';
import updateEnableDisableServicesReducer from 'store/SuperAdmin/updateEnableDisableService/reducer';
import getCustomerExportReducer from 'store/SuperAdmin/customerExport/reducer';
import getAllProviderExportListReducer from 'store/SuperAdmin/ProviderExport/reducer';
import getAppointmentExportReducer from 'store/SuperAdmin/AppointmentExport/reducer';
import getSearchProviderReducer from 'store/SuperAdmin/searchProviderList/reducer';
import getSearchAppointmentReducer from 'store/SuperAdmin/searchAppointmentList/reducer';
import getSearchBranchProviderReducer from 'store/ProviderAdmin/getSearchBranchProvider/reducer';
import updateProviderStatusReducer from 'store/SuperAdmin/updateProviderStatus/reducer';
import getServiceLocationTypeReducer from 'store/SuperAdmin/serviceLocationType/reducer';
import getAddOnServiceReducer from 'store/ProviderAdmin/addOnService/reducer';
import getCampaignTypeReducer from 'store/SuperAdmin/getCampaignType/reducer';
import getDiscountTypeReducer from 'store/SuperAdmin/getDiscountType/reducer';
import addCampaignReducer from 'store/SuperAdmin/createCampaign/reducer';
import getCampaignListReducer from 'store/SuperAdmin/getCampaign/reducer';
import deleteCampaignReducer from 'store/SuperAdmin/deleteCampaign/reducer';
import getAssociationReducer from 'store/SuperAdmin/getAssociationsList/reducer';
import updateCampaignReducer from 'store/SuperAdmin/updateCampaign/reducer';
import getCouponListReducer from 'store/SuperAdmin/getCoupon/reducer';
import addCouponReducer from 'store/SuperAdmin/createCoupon/reducer';
import updateCampaignStatusReducer from 'store/SuperAdmin/updateCampaignStatus/reducer';
import getAssignSpecialistListProviderReducer from 'store/ProviderAdmin/assignSpecialistList/reducer';
import assignSpecialistProviderReducer from 'store/ProviderAdmin/assignSpecialist/reducer';
import assignSpecialistVerifyProviderReducer from 'store/ProviderAdmin/assignSpecialistVerify/reducer';
import postCompleteJobProviderReducer from 'store/ProviderAdmin/completeJob/reducer';
import sendOtpReducer from 'store/SendOtp/reducer';
import verifyOtpReducer from 'store/VerifyOtp/reducer';
import logoutReducer from 'store/logout/reducer';
import getCurencyListReducer from 'store/SuperAdmin/getCurrency/reducer';
import getServiceOfferedReducer from 'store/ProviderAdmin/serviceOffered/reducer';
import getProviderServiceReducer from 'store/ProviderAdmin/getProviderService/reducer';
import getProviderSubCategoryReducer from 'store/ProviderAdmin/getProviderSubCategory/reducer';
import getProviderSalonListReducer from 'store/SuperAdmin/getProviderSalonList/reducer';
import fileUploadReducer from 'store/FileUpload/reducer';
import forgotPasswordReducer from 'store/forgotPassword/reducer';
import resendInvitationReducer from 'store/ProviderAdmin/resendInvitation/reducer';
import updateSpecialistReducer from 'store/ProviderAdmin/updateSpecialist/reducer';
import massUploadServicesReducer from 'store/ProviderAdmin/massUploadServices/reducer';
import getUsersListReducer from 'store/ProviderAdmin/getUsersList/reducer';
import registerUserReducer from 'store/ProviderAdmin/registerUser/reducer';
import getTimeSlotsReducer from 'store/ProviderAdmin/getTimeSlots/reducer';
import webCheckoutReducer from 'store/ProviderAdmin/webCheckout/reducer';
import getServiceStylistsReducer from 'store/ProviderAdmin/getServiceStylists/reducer';
import deleteProviderRequestReducer from './ProviderAdmin/DeleteProviderRequest/reducer';
import updateSalonProviderReducer from './ProviderRegister/reducer';
import pageTitleReducer from './pageTitle/reducer';

export default combineReducers({
  loginReducer,
  basicDetailsReducer,
  addCategoryReducer,
  addSubCategoryReducer,
  addServiceReducer,
  deleteCategoryReducer,
  deleteSubCategoryReducer,
  deleteServiceReducer,
  getCategoryReducer,
  getSubCategoryReducer,
  updateCategoryReducer,
  updateSubCategoryReducer,
  updateServiceReducer,
  addAppointmentsReducer,
  getAppointmentsReducer,
  updateAppointmentsReducer,
  registerInviteBusinessReducer,
  createPasswordReducer,
  tokenVerifyReducer,
  getAllProviderListReducer,
  getAllProviderListDetailsReducer,
  promoteProviderReducer,
  onHoldProviderReducer,
  addSalonProviderReducer,
  addCompanyProviderReducer,
  countryCityDropdownReducer,
  imageUploadReducer,
  updateAllProviderListDetailsReducer,
  addCompanyBranchProviderReducer,
  userMeReducer,
  getCompanyBranchProviderReducer,
  createSpecialistProviderReducer,
  getSpecialistProviderReducer,
  updateSpecialistStatusProviderReducer,
  getAllProviderInformationDetailsReducer,
  getBasicProviderInforrmationReducer,
  getBranchDetailsProviderReducer,
  deleteBranchListReducer,
  getDashboardDataReducer,
  getCustomerReducer,
  getAppointmentReducer,
  getAppointmentDetailsReducer,
  getCustomerDetailsReducer,
  getDashboardProviderDataReducer,
  cancelSpecialistInvitationReducer,
  updateCompanyBranchProviderReducer,
  getCustomerProviderReducer,
  getAppointmentsListReducer,
  getCustomerDetailProviderReducer,
  getAppointmentDaysReducer,
  deleteProviderReducer,
  cancelAppointmentReducer,
  cancelAppointmentProviderAdminReducer,
  updateProfileReducer,
  deleteCustomerProviderReducer,
  deleteCustomerSuperAdminReducer,
  updateEnableDisableServicesReducer,
  getCustomerExportReducer,
  getAllProviderExportListReducer,
  getAppointmentExportReducer,
  getSearchProviderReducer,
  getSearchAppointmentReducer,
  getSearchBranchProviderReducer,
  updateProviderStatusReducer,
  getServiceLocationTypeReducer,
  getAddOnServiceReducer,
  getCampaignTypeReducer,
  getDiscountTypeReducer,
  addCampaignReducer,
  getCampaignListReducer,
  deleteCampaignReducer,
  getAssociationReducer,
  updateCampaignReducer,
  getCouponListReducer,
  addCouponReducer,
  updateCampaignStatusReducer,
  getAssignSpecialistListProviderReducer,
  assignSpecialistProviderReducer,
  assignSpecialistVerifyProviderReducer,
  postCompleteJobProviderReducer,
  sendOtpReducer,
  verifyOtpReducer,
  logoutReducer,
  getCurencyListReducer,
  getServiceOfferedReducer,
  getProviderServiceReducer,
  getProviderSubCategoryReducer,
  getProviderSalonListReducer,
  fileUploadReducer,
  forgotPasswordReducer,
  resendInvitationReducer,
  updateSpecialistReducer,
  massUploadServicesReducer,
  getUsersListReducer,
  registerUserReducer,
  getTimeSlotsReducer,
  webCheckoutReducer,
  getServiceStylistsReducer,
  deleteProviderRequestReducer,
  updateSalonProviderReducer,
  pageTitleReducer,
});
